import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const FormContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 30%;
  min-width: 500px;
  border-radius: 0 30px 30px 0;
  background-color: white;
  flex-direction: column;
  position: absolute;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
`;

export const BackgroundImage = styled.img`
  height: 100%;
  min-width: calc(100vw - 450px);
`;

export const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 70vh;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-height: 900px) {
    min-height: 80vh;
  }
`;

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

export const LinkContainer = styled.div`
  min-width: max-content;
  display: flex;
  justify-content: space-between;
`;

export const Logo = styled.img`
  width: 60%;
  height: auto;
  margin-bottom: 50px;
`;

export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FooterLink = styled(Link)`
  font-size: 12px;
  margin: 0 8px;
`;

export const FormTitle = styled.h3`
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const ErrorText = styled(Text)`
  color: red;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

export const LoginInput = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  width: 400px;
  margin-top: 32px;
  border-bottom: 1px solid #000000;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const LockIcon = styled(InputIcon)`
  width: 14px;
  margin-right: 20px;
`;

export const EyeIcon = styled(InputIcon)`
  width: 18px;
`;

export const Input = styled.input`
  border: none;
  max-width: 100%;
  width: 100%;
  &:focus {
    outline: none;
  }
`;
